/**
 *
 * @class core-ui/utils/CsrfUtil
 * @date 09/01/2016
 * by: Carl Bellitti
 * @copyright 2016 Empower Retirement
 * @description
 *
 *      Helper class to make Csrf Handling code available to both liat-UI and core-ui
 *      
 */

"use strict";

var CsrfUtil = {

	 /**
     *
     * @function handleRequest
     * @memberOf core-ui/util/CsrfUtil
     * @param {String} token
     * @param {Object} config
     * @param {boolean} enableCSRF
     * @description updates the headers property of the config object if token is valid and can enable the CSRF checking
     * @returns {object} the updated config object
     *
     */

	handleRequest: function(token, config, enableCSRF) {

        if(token) {
            config.headers['X-CSRF-TOKEN'] = token;           
        }
        //Adding this enables the CSRF check (if enableCSRF is true).
      //  if(enableCSRF)
        //	config.headers['reqSource'] = 'browser';
        return config;

	},

	 /**
     *
     * @function handleResponse
     * @memberOf core-ui/util/CsrfUtil
     * @param {Object} response
     * @description updates the document cookie based on the headers propert of the repsonse
     * @returns void
     *
     */
	handleResponse: function(response) {

        return;

		/**var csrfToken = response.headers('X-CSRF-TOKEN');
        if (csrfToken !== null && csrfToken.indexOf('null') < 0) {
            document.cookie = "X-CSRF-TOKEN="
                + response.headers('X-CSRF-TOKEN')
                + ("; path=/participant");
        }*/
	}

};
export default CsrfUtil;
